<qaroni-status-preview
  [status]="status() | tasksStatus"
  [bgColorClass]="bgColorClass" />
